import { TitleWrap, Title, Text } from '@/vdp/AlertModal';
import { useDDAddAction } from '~/hooks/common/telemetry';
import AlertIcon from './AlertIcon';

const VehicleSold = () => {
  useDDAddAction('Vehicle Sold - Banner Shown');

  return (
    <>
      <TitleWrap>
        <AlertIcon />
        <Title>Vehicle Sold</Title>
      </TitleWrap>
      <Text>
        We’re sorry, another customer has purchased this vehicle. Below are some
        similar vehicles you may be interested in.
      </Text>
    </>
  );
};

export default VehicleSold;
